import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import format from 'date-fns/format';
import { FaCaretDown, FaCaretLeft, FaCaretRight } from 'react-icons/fa';
import 'react-datepicker/dist/react-datepicker.css';
import MONTHS from 'assets/data/months';
import { DatePickerContainer, StyledSelectedDate, MonthHeader } from './styled';

const SelectedDate = React.forwardRef(({ value, onClick, variant, disabled }, ref) => (
  <StyledSelectedDate
    onClick={onClick}
    ref={ref}
    variant={variant}
    isPlaceholder={!value}
  >
    {value ? format(new Date(value), 'MMM dd, yyyy') : 'Select a date'}
    {!disabled && <FaCaretDown />}
  </StyledSelectedDate>
));

SelectedDate.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['dark', 'light', 'blue', 'turquoise']),
  disabled: PropTypes.bool
};

const DatePicker = ({
  selectedDate,
  maxDate,
  minDate,
  startDate,
  endDate,
  onDateSelected,
  selectsStart,
  selectsEnd,
  variant,
  disabled = false,
  className,
  filterDate
}) => {
  return (
    <DatePickerContainer className={className}>
      <ReactDatePicker
        formatWeekDay={(nameOfDay) => nameOfDay.charAt(0)}
        showPopperArrow={false}
        customInput={<SelectedDate variant={variant} disabled={disabled} />}
        disabled={disabled}
        renderCustomHeader={({
          date,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled
        }) => (
          <MonthHeader>
            <button
              type="button"
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              <FaCaretLeft />
            </button>

            <select
              value={MONTHS[date.getMonth()]}
              onChange={({ target: { value } }) => changeMonth(MONTHS.indexOf(value))}
            >
              {MONTHS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <button
              type="button"
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              <FaCaretRight />
            </button>
          </MonthHeader>
        )}
        selected={selectedDate}
        placeholderText="Select date"
        maxDate={maxDate}
        minDate={minDate}
        startDate={startDate}
        endDate={endDate}
        selectsStart={selectsStart}
        selectsEnd={selectsEnd}
        onChange={(date) => onDateSelected(date)}
        filterDate={filterDate}
      />
    </DatePickerContainer>
  );
};

DatePicker.propTypes = {
  selectedDate: PropTypes.instanceOf(Date),
  onDateSelected: PropTypes.func.isRequired,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  selectsStart: PropTypes.bool,
  selectsEnd: PropTypes.bool,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  variant: PropTypes.oneOf(['dark', 'light', 'blue', 'turquoise']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  filterDate: PropTypes.func
};

DatePicker.defaultProps = {
  variant: 'light',
  filterDate: () => true
};

export default DatePicker;
